var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row"},[_c('div',{staticClass:"left-menu"},[_c('el-tree',{attrs:{"data":_vm.menuList,"props":_vm.defaultProps,"accordion":""},on:{"node-click":_vm.handleNodeClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }